export default "__VITE_ASSET__DsTtVoKT__"